import { render } from "./components-select.vue?vue&type=template&id=0f1ef9a8"
import script from "./components-select.vue?vue&type=script&lang=js"
export * from "./components-select.vue?vue&type=script&lang=js"

import "./components-select.vue?vue&type=style&index=0&id=0f1ef9a8&lang=less"

import exportComponent from "/Users/zhanghui/Documents/workSpace/github/coco-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__